import { ChangePasswordForm } from '../../../components/forms/users'
import { Modal } from '../../../components/modal'
import { toggleChangePasswordModal } from "../../../redux/slices/globalSlice"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

export const ChangePasswordImport = {
    ChangePasswordForm,
    Modal,
    toggleChangePasswordModal,
    useDispatch,
    useSelector,
    useTranslation
}